//
export const watch = {
  isOwner(value) {
    if (typeof value === 'boolean') {
      this.determineRows()
    }
  }
}
